<template>
  <PrivacySection title="2. Titolare del Trattamento">
    <p>
      Il Titolare del Trattamento dei dati personali è:
    </p>
    <PrivacyBox>
      <p><strong>ISIGest S.r.l.</strong></p>
      <p>Sede legale: Napoli (NA) Centro Direzionale Napoli Isola G1 Scala C Interno 94</p>
      <p>Email: <a href="mailto:info@isigest.net">info@isigest.net</a></p>
      <p>Telefono: <a href="tel:+390828725141">+39 0828 725141</a></p>
      <p>Sito web: <a href="https://www.isigest.net" target="_blank">www.isigest.net</a></p>
    </PrivacyBox>
    <p>
      Per qualsiasi richiesta relativa al trattamento dei dati personali, è possibile 
      contattarci utilizzando i recapiti sopra indicati, all'indirizzo email 
      <a href="mailto:info@appscontrini.it">info@appscontrini.it</a> o attraverso la 
      sezione "Contattaci" del sito web o dell'applicazione.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'
import PrivacyBox from '../PrivacyBox.vue'

export default {
  name: 'DataControllerSection',
  components: {
    PrivacySection,
    PrivacyBox
  }
}
</script>

